import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/personalspace/no_network_btn.png';
const _withScopeId = n => (_pushScopeId("data-v-ad63ecee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "no-network_container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode($setup["StatusCom"], {
    status: "noNetwork"
  }, {
    more: _withCtx(() => [_createElementVNode("img", {
      class: "no-network_button",
      src: _imports_0,
      onClick: $setup.handleRefresh
    })]),
    _: 1
  })]);
}